import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import {
  URL_TARIFF_CI_CO,
  URL_TARIFF_DISCOUNT,
  URL_TARIFF_INTEREST,
  URL_TARIFF_IRREGULAR_QUOTAS,
  URL_TARIFF_LEASING,
} from '@app/@core/constants/routes.constants';
import { UserAttributionsEnum } from '@app/@core/constants/user-credentials.constants';
import { CredentialsService, AuthenticationService } from '@app/login';

@Injectable({
  providedIn: 'root',
})
export class TariffGuard implements CanActivate {
  constructor(
    private router: Router,
    private credentialsService: CredentialsService,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log(state.url);
    if (this.credentialsService.isAuthenticated()) {
      if (
        state.url === URL_TARIFF_DISCOUNT &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_DISCOUNT_COMMERCE) &&
        this.authenticationService.permissionURL(URL_TARIFF_DISCOUNT)
      ) {
        return true;
      } else if (
        state.url === URL_TARIFF_INTEREST &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_INTEREST_CLIENT) &&
        this.authenticationService.permissionURL(URL_TARIFF_INTEREST)
      ) {
        return true;
      } else if (
        state.url === URL_TARIFF_CI_CO &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_CI_CO_AUTO) &&
        this.authenticationService.permissionURL(URL_TARIFF_CI_CO)
      ) {
        return true;
      } else if (
        state.url === URL_TARIFF_LEASING &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_LEASING_AUTO) &&
        this.authenticationService.permissionURL(URL_TARIFF_LEASING)
      ) {
        return true;
      } else if (
        state.url === URL_TARIFF_IRREGULAR_QUOTAS &&
        this.authenticationService.permissionAction(UserAttributionsEnum.ATTR_TARIFF_SHEET_IRREGULAR_QUOTA) &&
        this.authenticationService.permissionURL(URL_TARIFF_IRREGULAR_QUOTAS)
      ) {
        return true;
      } else {
        this.router.navigate(['/**'], { replaceUrl: true });
        return false;
      }
    } else {
      return false;
    }
  }
}
